import { useI18n } from "@/shared/i18n"
import { cn } from "@/shared/lib/utils"

export type InventoryTabKey = "assets" | "marketplace"

interface InventoryTabsProps {
  active: InventoryTabKey
  onChange?: (key: InventoryTabKey) => void
}

export function InventoryTabs({ active, onChange }: InventoryTabsProps) {
  const { t } = useI18n()

  const handleClick = (key: InventoryTabKey) => {
    if (key === active) return
    onChange?.(key)
  }

  const tabs: Array<{ key: InventoryTabKey; label: string }> = [
    { key: "assets", label: t("inventory.tabMyAssets") },
    { key: "marketplace", label: t("inventory.tabMarketplace") },
  ]

  return (
    <div className="px-4 pt-2 pb-2">
      <div
        role="tablist"
        className="flex h-[35px] w-full items-center gap-0 rounded-full bg-gray-32 p-0.5"
      >
        {tabs.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={active === key}
            onClick={() => handleClick(key)}
            className={cn(
              "flex h-[31px] flex-1 items-center justify-center rounded-full px-2.5 text-[16px] font-medium leading-[19px] tracking-[-0.5px] text-white transition-colors",
              active === key ? "bg-gray-100" : "bg-transparent"
            )}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  )
}
